import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div className="flex flex-col gap-3">
      <h1 className="text-2xl font-bold">Page not found</h1>
      <p className="text-sm text-muted-foreground">The URL you visited doesn&apos;t match any known route.</p>
      <Link to="/" className="text-sm underline">
        ← Back to home
      </Link>
    </div>
  );
}
